import { PermissionGroup } from ".";

export class ActivityOwner
{
    constructor(
        public userId:string,
        public name:string,
        public permissionGroup:PermissionGroup,
        public email:string
    ) { }
}